import React, { FunctionComponent, useContext } from "react";
import Context from "../../context/Context";
import { useEventContext } from "../../context/EventProvider";
import PresentedInfo from "../presented";
import Privacy from "../privacy";

const Footer: FunctionComponent = (props: any) => {
const {event: { hashtag, navLockUp: {url}, siteName, addresses}} = useEventContext();
const data = useContext(Context);
const { socialShare } = data;
const {addressLocality, addressRegion, location} = addresses.length > 0 && addresses[0];
const address =  `${addressLocality}, ${addressRegion}`

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-logo-and-cta">
        <div className='logo-innovate-container'>
          <img className="footer-aws" src={url} alt="Logo" />
              <div>
              <h1><b>Innovate Day</b></h1>
              <div className="subtitle-address">{address}</div>
              </div>
            </div>
            <h3>Federal Civilian Government</h3>
          <br />
          <PresentedInfo />
          <Privacy />
        </div>
        <div className="footer-social-icons">
          <div className="hashtag">{hashtag}</div>
          {socialShare.filter(social => social.alt !== "email").map((social, index: number) => (
            <div>
          <a
            key={index}
            className="socialm"
            href={`${social.path}https://awsinnovateday.upgather.com`}
            target={"_blank"}
            >{social.alt}
          </a>
            </div>  
        ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
